export default __webpack_public_path__ + "static/media/7_paypal.a130af89.svg";